(function () {
  var configElement = document.getElementById('cs-csc-age-gate-config');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }
  if (!config.title || !config.confirm || !config.decline) return;

  var storageKey = 'cs_age_gate_confirmed_v1';
  var legacyStorageKey = 'cs_csc_age_gate_confirmed_v1';
  var redirectUrl = '/';

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[character];
    });
  }

  function getConfirmed() {
    try {
      return window.localStorage.getItem(storageKey) === 'yes' || window.localStorage.getItem(legacyStorageKey) === 'yes';
    } catch (error) {
      return false;
    }
  }

  function setConfirmed() {
    try {
      window.localStorage.setItem(storageKey, 'yes');
      window.localStorage.setItem(storageKey + '_at', new Date().toISOString());
    } catch (error) {
      // localStorage may be unavailable in strict privacy modes; the current session can still continue.
    }
  }

  if (getConfirmed()) return;

  var overlay = document.createElement('div');
  overlay.className = 'cs-csc-age-gate';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'cs-csc-age-gate-title');
  overlay.innerHTML = [
    '<div class="cs-csc-age-gate__panel">',
    '  <p class="cs-csc-age-gate__eyebrow">' + escapeHtml(config.eyebrow) + '</p>',
    '  <h2 class="cs-csc-age-gate__title" id="cs-csc-age-gate-title">' + escapeHtml(config.title) + '</h2>',
    '  <p class="cs-csc-age-gate__text">' + escapeHtml(config.text) + '</p>',
    '  <p class="cs-csc-age-gate__text">' + escapeHtml(config.required) + '</p>',
    '  <div class="cs-csc-age-gate__actions">',
    '    <button class="cs-csc-age-gate__button cs-csc-age-gate__button--primary" type="button" data-cs-csc-age-yes>' + escapeHtml(config.confirm) + '</button>',
    '    <button class="cs-csc-age-gate__button cs-csc-age-gate__button--secondary" type="button" data-cs-csc-age-no>' + escapeHtml(config.decline) + '</button>',
    '  </div>',
    '  <p class="cs-csc-age-gate__note">' + escapeHtml(config.note) + '</p>',
    '</div>'
  ].join('');

  function lockPage() {
    document.documentElement.classList.add('cs-csc-age-gate-lock');
    document.body.classList.add('cs-csc-age-gate-lock');
  }

  function unlockPage() {
    document.documentElement.classList.remove('cs-csc-age-gate-lock');
    document.body.classList.remove('cs-csc-age-gate-lock');
  }

  function showUnderageMessage() {
    var panel = overlay.querySelector('.cs-csc-age-gate__panel');
    if (!panel) return;
    panel.innerHTML = [
      '<p class="cs-csc-age-gate__eyebrow">' + escapeHtml(config.underage_eyebrow) + '</p>',
      '<h2 class="cs-csc-age-gate__title">' + escapeHtml(config.underage_title) + '</h2>',
      '<p class="cs-csc-age-gate__text">' + escapeHtml(config.underage_text) + '</p>',
      '<p class="cs-csc-age-gate__text">' + escapeHtml(config.underage_redirect) + '</p>'
    ].join('');
    window.setTimeout(function () {
      window.location.assign(redirectUrl);
    }, 1800);
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    var focusable = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function mount() {
    document.body.appendChild(overlay);
    lockPage();
    overlay.addEventListener('keydown', trapFocus);
    overlay.querySelector('[data-cs-csc-age-yes]').addEventListener('click', function () {
      setConfirmed();
      unlockPage();
      overlay.remove();
    });
    overlay.querySelector('[data-cs-csc-age-no]').addEventListener('click', showUnderageMessage);
    window.setTimeout(function () {
      var yesButton = overlay.querySelector('[data-cs-csc-age-yes]');
      if (yesButton) yesButton.focus();
    }, 60);
  }

  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount, { once: true });
})();
